import React from "react";
import { ReactComponent as JAVASCRIPT } from "../img/skill_icons/javascript.svg";

export const JavaScript = () => {
  return <JAVASCRIPT title="javascript" />;
};
